import React from 'react'
import { TNAppDownloadButtons } from '../TNAppDownloadButtons/TNAppDownloadButtons'
import {
    AppDownloadButtonsSection,
    AppDownloadContentSectionTop,
    InnerAppDownloadTextSectionTop,
    StyledAppDownloadSectionTop,
    StyledQRCodeContainer,
    StyledTNLogo,
    StyledAppDownloadSubText,
    StyledAppDownloadTitle,
} from './TNAppDownloadContent.styled'
import { DownloadTheNightlyQrCode } from '../assets/download_thenightly_qr_code'

export function TNAppDownloadContent() {
    return (
        <StyledAppDownloadSectionTop>
            <AppDownloadContentSectionTop>
                <StyledTNLogo />
                <InnerAppDownloadTextSectionTop>
                    <StyledAppDownloadTitle>
                        The news companion for smart Australians who want to be
                        challenged.
                    </StyledAppDownloadTitle>
                    <StyledAppDownloadSubText>
                        Get the most out of your news with the FREE Nightly app.
                        <br />
                        Available for iOS and Android.
                    </StyledAppDownloadSubText>
                </InnerAppDownloadTextSectionTop>
                <AppDownloadButtonsSection>
                    <TNAppDownloadButtons />
                </AppDownloadButtonsSection>
                <StyledQRCodeContainer>
                    <DownloadTheNightlyQrCode />
                </StyledQRCodeContainer>
            </AppDownloadContentSectionTop>
        </StyledAppDownloadSectionTop>
    )
}
